import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import RosterSection from './components/RosterSection';
import AuthCTA from './components/AuthCTA';
import AuthDialog from './components/AuthDialog';
import { Toaster } from './components/ui/toaster';
import Pricing from './pages/Pricing';
import CheckoutSuccess from './pages/CheckoutSuccess';
import Legal from './pages/Legal';
import Workspace from './pages/Workspace';
import CookieBanner from './components/CookieBanner';

const HirePage = () => {
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState('signin');

  const openAuth = (mode) => {
    setAuthMode(mode);
    setAuthOpen(true);
  };

  return (
    <div className="min-h-screen bg-white text-neutral-900 antialiased">
      <Navbar onSignIn={() => openAuth('signin')} onSignUp={() => openAuth('signup')} />
      <HeroSection />
      <RosterSection />
      <AuthCTA onSignIn={() => openAuth('signin')} onSignUp={() => openAuth('signup')} />
      <footer className="border-t border-neutral-200 bg-white">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 py-8 text-xs text-neutral-500 sm:flex-row">
          <div className="flex items-center gap-2">
            <img src="https://customer-assets.emergentagent.com/job_hire-platform-22/artifacts/01uzdzol_LOGO%20AMAIA.jpg" alt="AMAIA.CLOUD" className="h-5 w-auto" />
            <span>© {new Date().getFullYear()} AMAIA.CLOUD — Augmented Mankind Abilities powered by AI</span>
          </div>
          <div className="flex gap-5">
            <a href="/legal" className="hover:text-neutral-900">Privacy</a>
            <a href="/legal" className="hover:text-neutral-900">Terms</a>
            <a href="/legal" className="hover:text-neutral-900">GDPR</a>
          </div>
        </div>
      </footer>

      <AuthDialog
        open={authOpen}
        onOpenChange={setAuthOpen}
        mode={authMode}
        onSwitch={(m) => setAuthMode(m)}
      />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HirePage />} />
          <Route path="/hire-worker" element={<HirePage />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/workspace" element={<Workspace />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
